import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e73bd9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading" }, "Q&A Excelインポート", -1))
const _hoisted_2 = { class: "mt20" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ファイルを選択")
const _hoisted_4 = { class: "explanation" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Explanation from '@/components/project_import/Explanation.vue'
import ExcelImportConfirm from '@/components/project_import/ExcelImportConfirm.vue'
import { useExcelUpload } from '@/logic/questionImport/ExcelUploadLogic'
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const importUrl: string = process.env.VUE_APP_DOMAIN + `/v1/projects/${route.params.project_id}/questions/bulk_create_confirm`;
const importPostData = { "project_id": route.params.project_id };
const store = useStore();
// const managerFlg = computed(() => store.state.login.manager_flg);
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const {
  confirmDialogState,
  handleSuccess,
  handleError,
  handleSubmit,
} = useExcelUpload(route.params.project_id);

const headers = {
  client: window.localStorage.getItem('client'),
  'access-token': window.localStorage.getItem('access-token'),
  uid: window.localStorage.getItem('uid'),
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(managerFlg))
      ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_upload, {
                headers: headers,
                action: importUrl,
                data: importPostData,
                "show-file-list": false,
                "on-success": _unref(handleSuccess),
                "on-error": _unref(handleError),
                name: "questions[file]",
                accept: ".xlsx"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-success", "on-error"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(Explanation, {
                  project_id: Number(_unref(route).params.project_id)
                }, null, 8, ["project_id"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      width: "50%",
      modelValue: _unref(confirmDialogState).visible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(confirmDialogState).visible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(ExcelImportConfirm, {
          onOnSubmit: _unref(handleSubmit),
          data: _unref(confirmDialogState).data.slice(0, 5)
        }, null, 8, ["onOnSubmit", "data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})